var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"dropdownFloors",attrs:{"variant":"primary","toggle-class":"buttonToggle rounded"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_vm._v(" "+_vm._s(_vm.currentFloor.name)+" ")]},proxy:true}])},[_c('b-dropdown-header',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.$t('selectFloor'))+" ")]),_vm._l((_vm.floors),function(floor,idx){return _c('b-dropdown-item-button',{key:`${floor.id}__${idx}`,attrs:{"button-class":[
      'floor',
      {
        floorSelected: _vm.currentFloor.id === floor.id
      }
    ]},on:{"click":function($event){return _vm.onFloorSelection(floor)}}},[_vm._v(" "+_vm._s(floor.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }